import { NavLink, useNavigate, useParams } from "react-router";
import { ArrowLeft } from "lucide-react";
import t from "@/lang/lang";
import { useOmniOfferBaseDataShowQuery } from "@/services/backend/omni/offer/api/base-data-api";
import { OfferBaseDataFields } from "@/services/backend/omni/offer/components/offer-base-data-fields";
import { DeleteOfferBaseDataDialog } from "@/services/backend/omni/offer/components/delete-offer-base-data-dialog";
import { CompanyName } from "@/services/backend/company/components/company-name";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Button } from "@/shared/components/ui/button";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";

export function OmniOfferBaseDataRoute() {
  const { offerBaseDataId } = useParams();
  const navigate = useNavigate();
  const {
    data: baseData,
    isLoading,
    error,
  } = useOmniOfferBaseDataShowQuery({
    id: offerBaseDataId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }
  if (isLoading || !baseData) {
    return <CardSkeleton />;
  }

  return (
    <PersistenceContextProvider>
      <ErrValidationFailedContextProvider>
        <Card>
          <CardHeader>
            <CardTitle>
              <NavLink to="./..">
                <Button variant="outline" size="sm" className="m-0 mb-4">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  <span>{t("Übersicht")}</span>
                </Button>
              </NavLink>
              <div>{baseData.label}</div>
            </CardTitle>
            <CardDescription>
              <CompanyName companyId={baseData.companyId} />
            </CardDescription>
            <CardAction className="flex gap-3">
              <PersistenceStateUsingContext />
              <DeleteOfferBaseDataDialog
                baseData={baseData}
                onDeleted={() => navigate("..")}
              />
            </CardAction>
          </CardHeader>
          <CardContent>
            <OfferBaseDataFields id={baseData.id} />
          </CardContent>
        </Card>
      </ErrValidationFailedContextProvider>
    </PersistenceContextProvider>
  );
}
